import React from 'react'
import { bool, func } from 'prop-types'

const MobileHeaderButton = ({ open, setOpen }) => {

  return (
    <div className='mobile-button'>
      <div onClick={() => {
        setOpen(!open)}
      }>
        <div className={`line-top line-default ${open ? 'trf-rz45' : 'none'}`}/>
        <div className={`line-default ${open ? 'op0 line-middle-open' : 'op1'}`}/>
        <div className={`line-bottom line-default ${open ? 'line-bottom-open' : ''}`}
        />
      </div>
    </div>
  )
}

export default MobileHeaderButton

MobileHeaderButton.propTypes = {
  open: bool,
  setOpen: func
}